// import React, { useState, useRef } from "react";

// const WeightReader = () => {
//   const [isConnected, setIsConnected] = useState(false);
//   const [weight, setWeight] = useState(0);
//   const [rawData, setRawData] = useState("");
//   const portRef = useRef(null);
//   const readerRef = useRef(null);
//   const keepReadingRef = useRef(false);

//   const BAUD_RATES = [9600, 4800, 19200];
//   const COMMANDS = ["S\r\n", "SI\r\n", "W\r\n", "P\r\n", "Q\r\n", "@00R\r\n"];

//   const connectToSerial = async () => {
//     try {
//       const selectedPort = await navigator.serial.requestPort();
//       portRef.current = selectedPort;

//       for (const baud of BAUD_RATES) {
//         try {
//           await selectedPort.open({
//             baudRate: baud,
//             dataBits: 8,
//             stopBits: 1,
//             parity: "none",
//             flowControl: "none",
//           });

//           console.log(`✅ Connected with baud rate ${baud}`);
//           setIsConnected(true);

//           const textDecoder = new TextDecoderStream();
//           selectedPort.readable
//             .pipeTo(textDecoder.writable)
//             .catch(() => {});
//           const reader = textDecoder.readable.getReader();
//           readerRef.current = reader;
//           keepReadingRef.current = true;

//           // Try all commands with delays
//           for (const cmd of COMMANDS) {
//             console.log(`📤 Trying command: "${cmd.replace(/\r\n/, "\\r\\n")}"`);
//             const writer = selectedPort.writable.getWriter();
//             await writer.write(new TextEncoder().encode(cmd));
//             writer.releaseLock();
//             await new Promise((r) => setTimeout(r, 1000)); // wait 1 sec
//           }

//           readWeight(reader);
//           break; // if open successful, stop trying baud rates
//         } catch (err) {
//           console.warn(`⚠️ Failed baud ${baud}, trying next...`, err);
//           try {
//             await selectedPort.close();
//           } catch {}
//         }
//       }
//     } catch (err) {
//       console.error("❌ Could not connect to RS232:", err);
//     }
//   };

// const readWeight = async (reader) => {
//   let buffer = "";
//   let lastWeight = null;

//   try {
//     while (keepReadingRef.current) {
//       const { value, done } = await reader.read();
//       if (done) break;
//       if (value) {
//         buffer += value;
//         const lines = buffer.split(/[\r\n]+/);
//         buffer = lines.pop();

//         for (const line of lines) {
//           // Extract number including decimals and possible negatives
//           const parsed = line.match(/[-+]?\d*\.?\d+/);
//           if (parsed && parsed[0]) {
//             const currentWeight = parsed[0].trim();

//             // Log only when weight changes (accurate comparison)
//             if (currentWeight !== lastWeight) {
//               lastWeight = currentWeight;
//               setWeight(currentWeight);
//               console.log("⚖️ Weight Changed:", currentWeight);
//             }
//           }
//         }
//       }
//     }
//   } catch (err) {
//     console.error("⚠️ Read error:", err);
//   } finally {
//     try {
//       reader.releaseLock();
//     } catch {}
//   }
// };



//  const disconnectSerial = async () => {
//   try {
//     console.log("🔌 Disconnecting...");
//     keepReadingRef.current = false;

//     // Cancel active reader safely
//     if (readerRef.current) {
//       try {
//         await readerRef.current.cancel();
//       } catch (err) {
//         console.warn("⚠️ Reader cancel failed (ok to ignore):", err);
//       }
//       try {
//         readerRef.current.releaseLock();
//       } catch (err) {
//         console.warn("⚠️ Reader release failed (ok to ignore):", err);
//       }
//       readerRef.current = null;
//     }

//     // Close the port safely
//     if (portRef.current) {
//       if (portRef.current.readable?.locked) {
//         console.warn("⚠️ Port readable stream locked, waiting before close...");
//         await new Promise((r) => setTimeout(r, 200));
//       }
//       await portRef.current.close();
//       console.log("✅ Serial port closed");
//       portRef.current = null;
//     }

//     // 🧹 Reset UI + States
//     setWeight(0);
//     setRawData("");
//     setIsConnected(false);
//     console.log("✅ Disconnected cleanly & weight reset");
//   } catch (err) {
//     console.error("❌ Error during disconnect:", err);
//   }
// };



//   return (
//     <div style={{ textAlign: "center", marginTop: "40px" }}>
//       <h2>⚖️ RS232 Weight Reader (Auto Test)</h2>
//       {!isConnected ? (
//         <button
//           onClick={connectToSerial}
//           style={{
//             padding: "10px 20px",
//             backgroundColor: "#28a745",
//             color: "#fff",
//             border: "none",
//             borderRadius: "6px",
//             cursor: "pointer",
//           }}
//         >
//           Connect to RS232
//         </button>
//       ) : (
//         <button
//           onClick={disconnectSerial}
//           style={{
//             padding: "10px 20px",
//             backgroundColor: "#dc3545",
//             color: "#fff",
//             border: "none",
//             borderRadius: "6px",
//             cursor: "pointer",
//           }}
//         >
//           Disconnect
//         </button>
//       )}

//       <h3 style={{ marginTop: "30px" }}>
//         Current Weight:{" "}
//         <span style={{ color: "#007bff" }}>
//           {weight > 0 ? `${weight} kg` : "Waiting..."}
//         </span>
//       </h3>

//       {/* <div style={{ marginTop: "20px", textAlign: "left", padding: "0 40px" }}>
//         <h4>🪵 Raw Serial Data:</h4>
//         <pre
//           style={{
//             background: "#f7f7f7",
//             padding: "10px",
//             height: "150px",
//             overflow: "auto",
//             borderRadius: "6px",
//             border: "1px solid #ccc",
//           }}
//         >
//           {rawData || "No data received yet..."}
//         </pre>
//       </div> */}
//     </div>
//   );
// };

// export default WeightReader;


// import React, { useState, useRef, useEffect } from "react";

// const WeightReader = () => {
//   const [isConnected, setIsConnected] = useState(false);
//   const [weight, setWeight] = useState(0);
//   const portRef = useRef(null);
//   const readerRef = useRef(null);
//   const keepReadingRef = useRef(false);

//   const BAUD_RATES = [9600, 4800, 19200];
//   const COMMANDS = ["S\r\n", "SI\r\n", "W\r\n", "P\r\n", "Q\r\n", "@00R\r\n"];

//   // ✅ Attempt auto-reconnect if browser remembers the port
//   useEffect(() => {
//     const tryReconnect = async () => {
//       try {
//         const ports = await navigator.serial.getPorts();
//         if (ports.length > 0) {
//           console.log("🔁 Trying to reconnect to previously granted port...");
//           portRef.current = ports[0];
//           await connectToSerial(ports[0]);
//         } else {
//           console.log("ℹ️ No pre-authorized serial ports found.");
//         }
//       } catch (err) {
//         console.error("Reconnect error:", err);
//       }
//     };

//     tryReconnect().catch((err) =>
//       console.error("Unhandled reconnect error:", err)
//     );

//     return () => {
//       if (keepReadingRef.current) {
//         disconnectSerial().catch((err) =>
//           console.error("Cleanup disconnect error:", err)
//         );
//       }
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const connectToSerial = async (existingPort = null) => {
//     try {
//       const port = existingPort || (await navigator.serial.requestPort());
//       portRef.current = port;

//       for (const baud of BAUD_RATES) {
//         try {
//           await port.open({
//             baudRate: baud,
//             dataBits: 8,
//             stopBits: 1,
//             parity: "none",
//             flowControl: "none",
//           });

//           console.log(`✅ Connected at ${baud} baud`);
//           setIsConnected(true);
//           localStorage.setItem("rs232Connected", "true");

//           const textDecoder = new TextDecoderStream();
//           const closedPromise = port.readable
//             .pipeTo(textDecoder.writable)
//             .catch((err) => console.warn("Stream closed:", err));

//           const reader = textDecoder.readable.getReader();
//           readerRef.current = reader;
//           keepReadingRef.current = true;

//           // send known commands
//           for (const cmd of COMMANDS) {
//             const writer = port.writable.getWriter();
//             await writer.write(new TextEncoder().encode(cmd));
//             writer.releaseLock();
//             await new Promise((r) => setTimeout(r, 500));
//           }

//           await readWeight(reader);
//           return;
//         } catch (err) {
//           console.warn(`⚠️ Failed baud ${baud}:`, err);
//           try {
//             await port.close();
//           } catch {}
//         }
//       }

//       console.error("❌ No baud rate worked.");
//     } catch (err) {
//       console.error("❌ connectToSerial failed:", err);
//     }
//   };

//   const readWeight = async (reader) => {
//     let buffer = "";
//     let lastWeight = "";

//     try {
//       while (keepReadingRef.current) {
//         const { value, done } = await reader.read();
//         if (done) break;
//         if (value) {
//           buffer += value;
//           const lines = buffer.split(/[\r\n]+/);
//           buffer = lines.pop();

//           for (const line of lines) {
//             const match = line.match(/[-+]?\d*\.?\d+/);
//             if (match) {
//               const current = match[0];
//               if (current !== lastWeight) {
//                 lastWeight = current;
//                 setWeight(current);
//                 console.log("⚖️ Weight:", current);
//               }
//             }
//           }
//         }
//       }
//     } catch (err) {
//       console.error("⚠️ Error while reading:", err);
//     } finally {
//       try {
//         reader.releaseLock();
//       } catch {}
//     }
//   };

//   const disconnectSerial = async () => {
//     try {
//       console.log("🔌 Disconnecting...");
//       keepReadingRef.current = false;

//       if (readerRef.current) {
//         try {
//           await readerRef.current.cancel();
//         } catch (err) {
//           console.warn("Reader cancel warning:", err);
//         }
//         try {
//           readerRef.current.releaseLock();
//         } catch (err) {
//           console.warn("Reader release warning:", err);
//         }
//         readerRef.current = null;
//       }

//       if (portRef.current) {
//         try {
//           await portRef.current.close();
//           console.log("✅ Port closed cleanly");
//         } catch (err) {
//           console.warn("Port close warning:", err);
//         }
//         portRef.current = null;
//       }

//       localStorage.removeItem("rs232Connected");
//       setIsConnected(false);
//       setWeight(0);
//       console.log("✅ Disconnected successfully");
//     } catch (err) {
//       console.error("❌ disconnectSerial failed:", err);
//     }
//   };

//   return (
//     <div style={{ textAlign: "center", marginTop: 40 }}>
//       <h2>⚖️ RS232 Weight Reader (Stable + Persistent)</h2>

//       {!isConnected ? (
//         <button
//           onClick={() => connectToSerial().catch(console.error)}
//           style={{
//             padding: "10px 20px",
//             backgroundColor: "#28a745",
//             color: "#fff",
//             border: "none",
//             borderRadius: 6,
//             cursor: "pointer",
//           }}
//         >
//           Connect to RS232
//         </button>
//       ) : (
//         <button
//           onClick={() => disconnectSerial().catch(console.error)}
//           style={{
//             padding: "10px 20px",
//             backgroundColor: "#dc3545",
//             color: "#fff",
//             border: "none",
//             borderRadius: 6,
//             cursor: "pointer",
//           }}
//         >
//           Disconnect
//         </button>
//       )}

//       <h3 style={{ marginTop: 30 }}>
//         Current Weight:{" "}
//         <span style={{ color: "#007bff" }}>
//           {weight > 0 ? `${weight} kg` : "Waiting..."}
//         </span>
//       </h3>
//     </div>
//   );
// };

// export default WeightReader;

// import React, { useState, useRef, useEffect } from "react";
// import { toast } from "react-toastify";
// import WeightReaderManager from "./WeightReaderManager";

// const WeightReader = ({ onWeightChange }) => {
//   const [isConnected, setIsConnected] = useState(false);
//   const [weight, setWeight] = useState(0);
//   const portRef = useRef(null);
//   const readerRef = useRef(null);
//   const keepReadingRef = useRef(false);

//   const connectToSerial = async () => {
//     try {
//       const port = await navigator.serial.requestPort();
//       await port.open({ baudRate: 9600 });
//       portRef.current = port;
//       setIsConnected(true);
//       localStorage.setItem("rs232Connected", "true");
//       toast.success("✅ Serial Port Connected");

//       const textDecoder = new TextDecoderStream();
//       const readableStreamClosed = port.readable.pipeTo(textDecoder.writable);
//       const reader = textDecoder.readable.getReader();
//       readerRef.current = reader;
//       keepReadingRef.current = true;

//       readLoop(reader);
//     } catch (error) {
//       console.error("Connection error:", error);
//       toast.error("⚠️ Failed to connect to serial port");
//       setIsConnected(false);
//     }
//   };

//   const readLoop = async (reader) => {
//     let buffer = "";
//     try {
//       while (keepReadingRef.current) {
//         const { value, done } = await reader.read();
//         if (done) break;
//         if (value) {
//           buffer += value;
//           const lines = buffer.split(/[\r\n]+/);
//           buffer = lines.pop();
//           for (const line of lines) {
//             const match = line.match(/[-+]?\d*\.?\d+/);
//             if (match) {
//               let parsed = parseFloat(match[0]);
//               // ✅ Convert grams to kg when needed
//               if (parsed > 10) parsed = parsed / 1000;
//               const formatted = parseFloat(parsed.toFixed(3));
//               setWeight(formatted);
//               WeightReaderManager.notify(formatted);
//               if (onWeightChange) onWeightChange(formatted);
//             }
//           }
//         }
//       }
//     } catch (error) {
//       console.warn("⚠️ Serial read stopped:", error);
//     } finally {
//       try {
//         reader.releaseLock();
//       } catch {}
//     }
//   };

//   const disconnectSerial = async () => {
//     try {
//       keepReadingRef.current = false;
//       if (readerRef.current) {
//         await readerRef.current.cancel().catch(() => {});
//         readerRef.current.releaseLock();
//         readerRef.current = null;
//       }
//       if (portRef.current) {
//         await portRef.current.close().catch(() => {});
//         portRef.current = null;
//       }
//       setIsConnected(false);
//       setWeight(0);
//       localStorage.removeItem("rs232Connected");
//       WeightReaderManager.notify(0);
//       toast.info("🔌 Disconnected");
//     } catch (error) {
//       console.error("Disconnect error:", error);
//       toast.error("⚠️ Error while disconnecting");
//     }
//   };

//   useEffect(() => {
//     const wasConnected = localStorage.getItem("rs232Connected") === "true";
//     if (wasConnected) {
//       WeightReaderManager.tryReconnect().then(() => setIsConnected(true)).catch(() => {});
//     }

//     return () => {
//       keepReadingRef.current = false;
//       if (readerRef.current) readerRef.current.cancel().catch(() => {});
//       if (portRef.current) portRef.current.close().catch(() => {});
//     };
//   }, []);

//   return (
//     <div
//     //   style={{
//     //     textAlign: "center",
//     //     margin: "20px auto",
//     //     padding: "12px",
//     //     border: "1px solid #ddd",
//     //     borderRadius: "10px",
//     //     width: "280px",
//     //     background: "#fafafa",
//     //   }}
//     >
//       {/* <h3>
//         ⚖️ Current Weight:{" "}
//         <span style={{ color: "#007bff" }}>{weight.toFixed(3)} kg</span>
//       </h3> */}

//       {!isConnected ? (
//         <button
//           onClick={connectToSerial}
//           style={{
//             padding: "8px 16px",
//             background: "#28a745",
//             color: "white",
//             border: "none",
//             borderRadius: "6px",
//             cursor: "pointer",
//             marginTop: "10px",
//           }}
//         >
//           Connect
//         </button>
//       ) : (
//         <button
//           onClick={disconnectSerial}
//           style={{
//             padding: "8px 16px",
//             background: "#dc3545",
//             color: "white",
//             border: "none",
//             borderRadius: "6px",
//             cursor: "pointer",
//             marginTop: "10px",
//           }}
//         >
//           Disconnect
//         </button>
//       )}
//     </div>
//   );
// };

// export default WeightReader;


import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import WeightReaderManager from "./WeightReaderManager";

const WeightReader = ({ onWeightChange }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [weight, setWeight] = useState(0);

  const connectToSerial = async () => {
    try {
      await WeightReaderManager.connectToSerial();
      setIsConnected(true);
      toast.success("✅ Serial Port Connected");
    } catch (err) {
      toast.error("⚠️ Failed to connect to serial port");
    }
  };

  const disconnectSerial = async () => {
    try {
      await WeightReaderManager.disconnect();
      setIsConnected(false);
      setWeight(0);
      toast.info("🔌 Disconnected");
    } catch (err) {
      toast.error("⚠️ Error while disconnecting");
    }
  };

  useEffect(() => {
    const unsubscribe = WeightReaderManager.subscribe((w) => {
      setWeight(w);
      if (onWeightChange) onWeightChange(w);
    });

    const wasConnected = localStorage.getItem("rs232Connected") === "true";
    if (wasConnected) WeightReaderManager.tryReconnect().then(() => setIsConnected(true));

    return () => unsubscribe();
  }, [onWeightChange]);

  return (
    <div style={{
      // textAlign: "end",
  }}>

      <div>
          {!isConnected ? (
        <button
          onClick={connectToSerial}
          style={{
            padding: "10px 16px",
            background: "#006400",
            color: "white",
            border: "none",
            borderRadius: "50px",
            cursor: "pointer",
            marginTop: "10px",
          }}
        >
          Connect
        </button>
      ) : (
        <button
          onClick={disconnectSerial}
          style={{
            padding: "10px 16px",
            background: "#dc3545",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            marginTop: "10px",
          }}
        >
          Disconnect
        </button>
      )}
      
      </div>
    <label
  style={{
    display: "block",
    //marginBottom: "10px",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "16px",
    color: "#373737",
  }}
>
  Connect Weight Machine
</label>
    </div>
  );
};

export default WeightReader;




